import { useQuery } from '@tanstack/react-query';

import { QUERY_STALE_TIMES } from '../../shared/providers/react-query-provider';

import { getDissatisfactionCategories } from './api';
import { DissatisfactionCategories } from './types';

/**
 * Query key factory for dissatisfaction categories
 * @param tripId - The trip ID to fetch dissatisfaction categories for
 */
export const getDissatisfactionCategoriesQueryKey = (tripId: string) =>
    ['dissatisfactionCategories', tripId] as const;

/**
 * Hook to fetch dissatisfaction categories for a specific trip
 * Used to display customer satisfaction issues in the testimonial modal
 *
 * @param tripId - The trip ID, can be null when no trip is selected
 * @returns Query result with dissatisfaction categories array
 *
 * @example
 * ```tsx
 * const { data: categories, isLoading } = useGetDissatisfactionCategories(trip?.id || null);
 * ```
 */
export const useGetDissatisfactionCategories = (tripId: string | null) => {
    return useQuery<DissatisfactionCategories>({
        queryKey: getDissatisfactionCategoriesQueryKey(tripId || ''),
        queryFn: () => getDissatisfactionCategories(tripId!),
        enabled: !!tripId,
        staleTime: QUERY_STALE_TIMES.DISSATISFACTION_CATEGORIES,
        refetchOnWindowFocus: false,
    });
};
